import NetworkPage from "../features/network/NetworkPage.js";

export default NetworkPage;
